export const CLOUDFLARE_IMAGE_BASE_URL = (
  process.env.REACT_APP_CLOUDFLARE_IMAGE_BASE_URL || "https://imagedelivery.net/nqrnaXbs-e6zRIPl6hexRg/"
).replace(/\/$/, "");

export const getCloudflareImageUrl = (imagePath, variant = "w=1900,sharpen=1") => {
  if (!imagePath) return "";

  const value = String(imagePath).trim().replace(/^["']|["']$/g, "");
  if (!value) return "";

  if (value.startsWith("/") && !value.startsWith("//")) return value;

  const normalizedVariant = variant ? String(variant).replace(/^\//, "") : "";
  const baseWithSlash = CLOUDFLARE_IMAGE_BASE_URL + "/";
  const [imageValue, queryString = ""] = value.split("?");
  const imageId = imageValue.startsWith(baseWithSlash) ? imageValue.slice(baseWithSlash.length) : imageValue;
  const cleanImageId = imageId.replace(/^\//, "").replace(/\/$/, "");
  const suffix = queryString ? `?${queryString}` : "";

  if (/^https?:\/\//i.test(cleanImageId) && !cleanImageId.startsWith(CLOUDFLARE_IMAGE_BASE_URL)) {
    return cleanImageId + suffix;
  }

  if (!normalizedVariant || /\/(w=|public$|thumbnail$)/i.test(cleanImageId)) {
    return baseWithSlash + cleanImageId + suffix;
  }

  return baseWithSlash + cleanImageId + "/" + normalizedVariant + suffix;
};
